import * as React from 'react';
import './eventWaitlistDescription.module.scss';

export const EventWaitlistDescription = () => (
  <div id="event-waitlist-description" styleName="event-waitlist-description">
    <div styleName="title">空き枠通知について</div>
    <div styleName="content">
      枠に空きが出た際にメールで通知をさせていただきます。通知のタイミングは下記二回です。
      <div styleName="list">
        <ul>
          <li>開催日前日の19時</li>
          <li>開催日当日の8時</li>
        </ul>
      </div>
    </div>
    <div styleName="note">
      ※空きが出ても他の方が先に予約をした場合は、予約ができない場合もございますのでご了承ください。
    </div>
  </div>
);
